import { AppLanguage } from 'app/config/i18Config/types';
import { Note } from 'entities/Note';
import { Warehouse } from 'entities/Warehouse';

export interface LeadData {
  firstName?: Nullable<string>;
  lastName?: Nullable<string>;
  email?: Nullable<string>;
  language?: Nullable<AppLanguage>;
  phone?: Nullable<string>;
  note?: Nullable<string>;
  warehouseId?: Nullable<string>;
  square?: Nullable<number>;
  userId?: Nullable<string>;
  userCreationDate?: Nullable<string>;
  isThirdPartyAuthorized?: boolean;
  isAutoMailingEnabled?: boolean;
  googleClickId?: Nullable<string>;
  googleClickIdDate?: Nullable<string>;
  firstContact?: Nullable<LeadFirstContact>;
}

export interface Lead {
  leadId: string;
  firstName?: Nullable<string>;
  lastName?: Nullable<string>;
  email?: Nullable<string>;
  phone?: Nullable<string>;
  language?: Nullable<AppLanguage>;
  note?: Nullable<string>;
  warehouseId?: Nullable<string>;
  warehouse?: Nullable<Warehouse>;
  contractId?: Nullable<string>;
  userId?: Nullable<string>;
  reservationId?: Nullable<string>;
  square?: Nullable<number>;
  isContractPaid?: boolean;
  isLeft?: boolean;
  isAutoMailingEnabled?: boolean;
  userCreationDate?: Nullable<string>;
  reservationDate?: Nullable<string>;
  contractCreationDate?: Nullable<string>;
  contractEndDate?: Nullable<string>;
  firstPaymentDate?: Nullable<string>;
  assignedNotes?: Note[];
  firstContact?: Nullable<LeadFirstContact>;
  leaveReason?: Nullable<LeadLeaveReason>;
  createdAt?: string;
  updatedAt?: string;
}

export interface SendOfferRentOptionData {
  label: string;
  description: string;
  units: string[];
}

export interface SendOfferParams {
  email: string;
  warehouseId: string;
  boxId: string[];
  language?: AppLanguage;
  rentOptionData?: SendOfferRentOptionData[];
}

export enum LeadStatus {
  ACTIVE = 'active request',
  RESERVATION = 'reservation',
  EXPIRED_RESERVATION = 'expired reservation',
  PAID = 'paid',
  NOT_PAID = 'not paid',
  END = 'end',
  LEFT = 'left',
  WITHOUT_BOOKINGS = 'without bookings',
}

export enum LeadFirstContact {
  BOOKING = 'booking',
  CONTACT_FORM = 'contact form',
  CALL = 'call',
  MAIL = 'mail',
  CHAT = 'chat',
  MESSENGER = 'messenger',
  OTHER = 'other',
}

export enum LeadLeaveReason {
  EXISTING_CLIENT = 'existing client',
  NOT_RELATED = 'not related',
  REJECTION = 'rejection',
  NO_CONTACT = 'no contact',
}
